import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'src/api/axiosBaseQuery'
import { API_BASE_PATH } from 'src/utils/constants'
import {
  AITrainerExerciseDetailsResponse,
  AITrainerExerciseListResponse,
  PaginationPayload,
  UpdateAITrainerPayload,
} from './types'

const API_ENDPOINT = '/api/v1/trainer'

const aiTrainerApi = createApi({
  reducerPath: 'aiTrainerApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_PATH,
  }),
  tagTypes: ['aiTrainerApi'],
  endpoints: (builder) => ({
    getAITrainerExerciseList: builder.query<AITrainerExerciseListResponse, PaginationPayload>({
      query: ({ page = 1, pageSize = 10, sortBy = '', search = '' }) => ({
        url: `${API_ENDPOINT}/admin_training_video/?q=${search}&page=${page}&page_size=${pageSize}${
          sortBy ? `&sort_by=${sortBy}` : ''
        }`,
        method: 'GET',
      }),
      transformResponse: (response: AITrainerExerciseListResponse) => {
        return response
      },
    }),

    uploadAITrainerExercise: builder.mutation<void, FormData>({
      query: (data) => ({
        url: `${API_ENDPOINT}/admin_training_video/`,
        method: 'POST',
        data: data,
      }),
    }),

    deleteAITrainerExercise: builder.mutation<void, number>({
      query: (id) => ({
        url: `${API_ENDPOINT}/admin_training_video/${id}/`,
        method: 'DELETE',
      }),
    }),

    getAITrainerExerciseDetailsById: builder.query<AITrainerExerciseDetailsResponse, number>({
      query: (id) => ({
        url: `${API_ENDPOINT}/admin_training_video/${id}/`,
        method: 'GET',
      }),
      transformResponse: (response: AITrainerExerciseDetailsResponse) => {
        return response
      },
    }),

    updateAITrainer: builder.mutation<void, UpdateAITrainerPayload>({
      query: ({ data, id }) => ({
        url: `${API_ENDPOINT}/admin_training_video/${id}/`,
        method: 'PATCH',
        data: data,
      }),
    }),
  }),
})

export const {
  useGetAITrainerExerciseListQuery,
  useUploadAITrainerExerciseMutation,
  useDeleteAITrainerExerciseMutation,
  useGetAITrainerExerciseDetailsByIdQuery,
  useUpdateAITrainerMutation,
} = aiTrainerApi
export default aiTrainerApi
